(() => {
  const selector = '[data-rolypulley-webcotter-study]';

  const begin = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const playback = video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch(() => {
        video.dataset.webcotterAutoplay = 'blocked';
      });
    }
  };

  const initialize = () => {
    document.querySelectorAll(selector).forEach((video) => {
      begin(video);
      video.addEventListener('canplay', () => begin(video), { once: true });
      video.addEventListener('loadeddata', () => begin(video), { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
